var map = {
	"./en-US": 335,
	"./en-US.es": 334,
	"./en-US.es.js": 334,
	"./en-US.js": 335,
	"./fr-FR": 337,
	"./fr-FR.es": 336,
	"./fr-FR.es.js": 336,
	"./fr-FR.js": 337,
	"./whitelist_en-US": 338,
	"./whitelist_en-US.js": 338,
	"./whitelist_fr-FR": 339,
	"./whitelist_fr-FR.js": 339
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 1060;
module.exports = webpackContext;